import { Injectable } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { environment } from '../../environments/environment';

@Injectable()
export class ConfigurationService {

  private baseUrl: string;
  private reportApiUrl: string;

  get BaseUrl(): string { return `${this.baseUrl}`; }
  get BaseApiUrl(): string { return `${this.baseUrl}api/`; }
  get BaseUploadUrl(): string { return `${this.baseUrl}upload/`; }
  get BasePdfReportUrl(): string { return `${this.baseUrl}download/pdf/`; }
  get BasePreviewUrl(): string { return `${this.baseUrl}preview/`; }
  get ReportApiUrl(): string { return `${this.reportApiUrl}`; }

  constructor(private strategy: LocationStrategy) {
    const url = this.strategy.getBaseHref();
    const port = new URL(url).port;
    if (environment.production === true || port !== '5010') {
      this.baseUrl =  url + '/';
      this.reportApiUrl = url + '/reporting';
    } else {
       this.baseUrl ='http://localhost:5003/';

       // this.baseUrl ='https://techverves.biz/';

      this.reportApiUrl = 'http://localhost:5000/reporting';//  'http://104.211.209.77:8000/';
    }
    console.log('Configuration service', this.baseUrl, this.strategy);
  }

  navigate(relativePath: string) {
    window.location.href = `${this.baseUrl}${relativePath.substring(1)}`;
  }
}
